import { styled } from 'styled-components'
import { Block } from 'suomifi-ui-components'
import media from 'common-ui-components/src/vtj/theme/media'

export const OrderWizardPageLayout = styled(Block)`
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 350px 1fr;
  grid-template-areas:
    'header header'
    'navigation content';
  grid-gap: ${({ theme }) => theme.spacing.xl};
  ${media.mobileAndTablet} {
    grid-template-columns: 1fr;
    grid-template-areas:
      'header'
      'navigation'
      'content';
  }
`

export const ContentGridItem = styled(Block)`
  grid-area: content;
`

export const ContentContainer = styled(Block)`
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.depthLight1};
  padding: ${({ theme }) => theme.spacing.m};
  ${media.mobileAndTablet} {
    padding: ${({ theme }) => theme.spacing.s};
  }
`

export const TitleGridItem = styled(Block)`
  grid-area: header;
  ${media.mobileAndTablet} {
    margin-left: ${({ theme }) => theme.spacing.s};
    margin-right: ${({ theme }) => theme.spacing.s};
  }
  h1 {
    padding-left: 0px;
    padding-right: 0px;
    margin-top: ${({ theme }) => theme.spacing.xl};
    margin-bottom: ${({ theme }) => theme.spacing.xl};
  }
  .fi-heading--h1 {
    line-height: 1.2;
    ${media.mobileAndTablet} {
      font-size: 32px;
    }
    ${media.mobileContent} {
      font-size: 28px;
    }
  }
`

export const NotificationContainer = styled(Block)`
  margin-top: -${({ theme }) => theme.spacing.xl};
`

export const SidebarGridItem = styled(Block)`
  grid-area: navigation;
`

export const WizardNavigationContainer = styled(Block)`
  padding: ${({ theme }) => theme.spacing.s} 0;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.depthLight1};

  ${media.mobileAndTablet} {
    padding: 0;
  }

  .fi-wizard-navigation-item--completed .fi-link[aria-disabled='true'] {
    // OIVA-4224: Disabled+completed link must visually appear disabled.
    // SFI-components doesn't have this out of the box, we make our own.
    color: ${({ theme }) => theme.colors.depthDark3};
    pointer-events: none;
    cursor: inherit;
  }
`
export const ControlsContainer = styled(Block)`
  .fi-inline-alert {
    margin-bottom: ${({ theme }) => theme.spacing.xl};
  }
`

export const ButtonsContainer = styled(Block)`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacing.s};
  grid-template-columns: minmax(0, auto) minmax(0, auto) minmax(0, auto);
  justify-content: end;
  & > button {
    min-width: 170px;
  }

  ${media.mobileAndTablet} {
    grid-template-columns: 1fr;
  }
`

export const ValidationErrorList = styled.ul`
  li {
    list-style: inside;
  }
`
